export const activityEnglish = {
  team_title: "Team activity",
  my_title: "My activity",
  team_subtitle:
    "Explore what each person works on, the apps they use, and their activity over time.",
  my_subtitle: "Review the work you've shared with Platonic.",
  scope: "Whose activity to show",
  scope_team: "Team",
  scope_only_you: "Only you",
  captured_time: "Captured time",
  people_with_data: "People with data",
  processes: "Processes",
  back_to_members: "Back to all members",
  team_members: "Team members",
  members_hint: "Select a person to explore their captured work.",
  search_people: "Search team members…",
  sort: "Sort team members",
  name: "Team member",
  daily: "Activity over time",
  sessions: "Sessions captured",
  sessions_short: "Sessions",
  show_more: "Show more",
  bin_days: "Bin: {{count}} days",
  bin_days_one: "Bin: {{count}} day",
  bin_hours: "Bin: {{count}} hours",
  bin_hours_one: "Bin: {{count}} hour",
  captured_in_view: "{{time}} captured in view",
  chart_gestures:
    "Cmd/Ctrl + scroll to zoom · Scroll horizontally or drag to pan · Double-click to reset",
  last_capture: "Last capture",
  across_days: "across {{count}} days",
  across_days_one: "across {{count}} day",
  last_capture_on: "last {{date}}",
  process_time: "Process time",
  process_time_hint: "Time spent on cases in the selected period, from analyzed, active sessions.",
  latest_session: "Latest session",
  member_view: "Member view",
  work_view: "Work",
  sessions_view: "Sessions",
  show_sessions: "Show sessions",
  open_session: "Open session",
  captured: "Captured",
  coverage: "Data coverage",
  data_present: "Data available",
  low_data: "Low data",
  no_data: "No data",
  member_details: "Captured work in the selected period",
  recent_sessions: "Recent sessions",
  clear_session_filters: "Clear",
  session_search: "Search by name",
  session_status: "Status",
  all_statuses: "All statuses",
  no_statuses: "No statuses",
  status_count: "Status ({{count}})",
  session_matches: "{{count}} of {{total}} sessions",
  analyzed: "Analyzed",
  analysis_starting: "Starting…",
  analyze_selected: "Analyze selected",
  analysis_start_failed: "Couldn't start analysis. Try again.",
  not_synced: "Not synced",
  loading_process_count: "Loading processes…",
  process_count_unavailable: "Process count unavailable",
  no_member_data:
    "No captured sessions for this person in the selected period. Try a wider date range or check their capture setup.",
  apps: "Apps used",
  distinct_work_counts:
    "Distinct processes with cases in the selected period, from analyzed, active sessions.",
  time_by_process: "Time by process",
  time_by_app: "Time by app",
  process_time_total: "{{time}} of observed process time · shares of this total",
  app_time_total: "{{time}} of measured app time · shares of this total",
  work_scope: "Based on cases in the selected period, from analyzed, active sessions.",
  work_load_failed: "Couldn't load process and app activity.",
  empty_processes: "No analyzed processes in this period.",
  empty_apps: "No measured app usage in this period.",
  show_less: "Show less",
  other: "Other",
  top_apps: "Top apps by time used",
  more_apps: "{{count}} more apps",
  more_apps_one: "{{count}} more app",
  active_analysis: "From analyzed, active sessions",
  in_period: "In the selected period and scope",
  your_shared_work: "Your shared work, in one place",
  your_shared_hint:
    "Review your sessions and the processes learned from them. You can manage which sessions contribute to process insights from each session's details.",
  capture_settings: "Review capture settings",
  empty_personal:
    "No sessions match this view. Try a wider date range, clear your search, or check your capture settings.",
  day_captured: "{{time}} captured",
  day_summary: "{{count}} sessions · {{time}} captured",
  day_summary_one: "{{count}} session · {{time}} captured",
  personal_hint: "Manage which sessions contribute to process insights.",
  select_matching: "Select all matching sessions",
  select_session: "Select {{name}}",
  session_actions: "Actions for {{name}}",
  session_name: "Session name",
  restore: "Restore",
  analyze_failed:
    "Couldn't start the analysis of {{count}} sessions. They remain selected so you can retry.",
  analyze_failed_one:
    "Couldn't start the analysis of {{count}} session. It remains selected so you can retry.",
  to_do: "To do",
  to_do_count: "{{count}} things to do",
  to_do_count_one: "{{count}} thing to do",
  review_sessions: "{{count}} sessions to review",
  review_sessions_one: "{{count}} session to review",
  unanalyzed_sessions: "{{count}} sessions to analyze",
  unanalyzed_sessions_one: "{{count}} session to analyze",
  unanalyzed_sessions_hint: "Your processes include only analyzed sessions.",
  processes_detected: "Distinct processes detected in this session",
  view_session: "View session",
  session_navigation: "Sessions from this person",
  older_session: "Previous session",
  newer_session: "Next session",
  no_older_session: "No previous session",
  no_newer_session: "No next session",
};
